module.exports = __webpack_public_path__ + "static/media/u45_premium_contract12.14cfba84.webp";